//@ts-nocheck
import { Modal } from "react-bootstrap";
import Button, { ButtonProps } from "../Button";
import * as app from "../../services/AppService"
import React, {  ReactElement } from "react"

export interface DialogProps {
    onClose?: (val?: any) => void;
    ok?: () => void;
    title?: string;
    show?: boolean;
    closeLabel?: string;
    okLabel?: string;
    size?: "sm" | "md" | "lg" | "xl" | "xxl";
    onFocus?: () => any;
    children?: ReactElement | ReactElement[];
    otherButtons?: ButtonProps[];
    containerClass?: string
}

export default function Dialog(props: Partial<DialogProps>) {


    function Close() {
        if (props.onClose && typeof (props.onClose) == "function")
            props.onClose();
    }

    function Ok() {
        if (props.ok && typeof (props.ok) == "function")
            props.ok()
    }

    function Clicked(clicked: any) {
        if (clicked && typeof (clicked) == "function")
            clicked()
    }

    return (
        <Modal className={` ${props.containerClass}`} data-bs-theme={app.getCookie("colorMode", window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light")} backdrop="static"
            show={props.show} size={props.size || 'sm'} onHide={Close} style={{ direction: app.translate("Lang") === "ar" ? "rtl" : "ltr" }}>
            <Modal.Header onClick={Close} className="p-2 border-bottom text-primary-emphasis bg-body-tertiary">
                <Modal.Title className="w-100">{app.translate(props.title)}</Modal.Title>
                {props.onClose && <Button class="btn-danger " clicked={Close} icon="close-1" iconClass="text-light" />}
            </Modal.Header>
            <Modal.Body className="p-2 text-start bg-body-tertiary " onFocus={props.onFocus} >{props.children}</Modal.Body>
            <Modal.Footer className="p-1 bg-body-tertiary border-top">
                {props.otherButtons && props.otherButtons.map((item, i) =>
                    <Button key={i} hide={item.hide} class={"btn-primary shadow-sm mx-1 " + item.class} disabled={item.disabled} type={item.type || "button"}
                        clicked={() => Clicked(item.clicked)} label={item.label} iconClass="text-light " labelClass="text-light fs-6" icon={item.icon} formID={item.formID} />)}
                <div className="col"></div>
                {props.onClose && <Button class="btn btn-danger" clicked={Close} label={props.closeLabel} labelClass="fs-6" icon="close-1" iconClass="" />}
                {props.ok && <Button class="btn btn-success" clicked={Ok} label={props.okLabel} iconClass="text-light" labelClass="text-light "
                    icon={props.okLabel === "Save" || props.okLabel === "Edit" ? "save" : props.okLabel === "Ok" ? "done-1" : props.okLabel === "Loading" ? "up-arrow" : ""} />}
            </Modal.Footer>
        </Modal>
    );
}


Dialog.defaultProps = {
    title: "",
    show: true,
    closeLabel: 'Close',
    okLabel: 'Ok',
}